import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { isEmptyString } from 'bmx-pastebox';
import * as i1 from '@angular/platform-browser';

class Constant {
    static { this.ROOT_URL = '/'; }
    static { this.AUTH_SUCCESS_ROUTE_KEY = 'dhsnKJHIyhkbYRTFVjkh'; }
    static { this.SITE_NAME = ''; }
}

class BmxAngularBaseModule {
    static setupConfig(config) {
        if (!config.rootUrl)
            config.rootUrl = Constant.ROOT_URL;
        if (!config.authSuccessRouteKey)
            config.authSuccessRouteKey = Constant.AUTH_SUCCESS_ROUTE_KEY;
        if (!config.siteName)
            config.siteName = Constant.SITE_NAME;
    }
    static forRoot(config) {
        BmxAngularBaseModule.setupConfig(config);
        return {
            ngModule: BmxAngularBaseModule,
            providers: [
                { provide: 'ROOT_URL', useValue: config.rootUrl },
                { provide: 'AUTH_SUCCESS_ROUTE_KEY', useValue: config.authSuccessRouteKey },
                { provide: 'SITE_NAME', useValue: config.siteName }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: BmxAngularBaseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.1.4", ngImport: i0, type: BmxAngularBaseModule, imports: [CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: BmxAngularBaseModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: BmxAngularBaseModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

class LocalStorageService {
    constructor(_rootUrl, _authSuccessRouteKey) {
        this.authSuccessRouteKey = Constant.AUTH_SUCCESS_ROUTE_KEY;
        this.rootUrl = Constant.ROOT_URL;
        if (_rootUrl)
            this.rootUrl = _rootUrl;
        if (_authSuccessRouteKey)
            this.authSuccessRouteKey = _authSuccessRouteKey;
    }
    store(key, value) {
        localStorage.setItem(key, value);
    }
    retrieve(key) {
        const value = localStorage.getItem(key);
        return (value === null) ? '' : value;
    }
    hasKey(key) {
        return this.retrieve(key) !== null;
    }
    clear() {
        localStorage.clear();
    }
    removeItems(keys) {
        keys.forEach((key, index) => localStorage.removeItem(key));
    }
    storeOnAuthSuccessRoute(route) {
        this.store(this.authSuccessRouteKey, route);
    }
    retrieveOnAuthSuccessRoute() {
        const route = this.retrieve(this.authSuccessRouteKey);
        return isEmptyString(route) ? this.rootUrl : route;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: LocalStorageService, deps: [{ token: 'ROOT_URL' }, { token: 'AUTH_SUCCESS_ROUTE_KEY' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: LocalStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['ROOT_URL']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AUTH_SUCCESS_ROUTE_KEY']
                }] }] });

class BrowserAPIService {
    constructor(_platformId, _document) {
        this._platformId = _platformId;
        this._document = _document;
    }
    document() {
        return this._document;
    }
    window() {
        return this._document.defaultView;
    }
    location() {
        return this._document.location;
    }
    createElement(tag) {
        return this._document.createElement(tag);
    }
    isBrowser() {
        return isPlatformBrowser(this._platformId);
    }
    isServer() {
        return isPlatformServer(this._platformId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: BrowserAPIService, deps: [{ token: PLATFORM_ID }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: BrowserAPIService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: BrowserAPIService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class FacebookSeoService {
    constructor(_meta, _siteName) {
        this._meta = _meta;
        this._siteName = _siteName;
    }
    _resolveSiteName(data) {
        if (!data.siteNameContent || isEmptyString(data.siteNameContent))
            return this._siteName;
        return data.siteNameContent;
    }
    _setTitle(title) {
        this._meta.updateTag({
            property: 'og:title',
            content: title
        });
    }
    _setType(type) {
        this._meta.updateTag({
            property: 'og:type',
            content: type
        });
    }
    _setDescription(description) {
        this._meta.updateTag({
            property: 'og:description',
            content: description
        });
    }
    _setImageUrl(url) {
        this._meta.updateTag({
            property: 'og:image',
            content: url
        });
    }
    _setImageType(type) {
        this._meta.updateTag({
            property: 'og:image:type',
            content: type
        });
    }
    _setImageWidth(width) {
        this._meta.updateTag({
            property: 'og:image:width',
            content: width
        });
    }
    _setImageHeight(height) {
        this._meta.updateTag({
            property: 'og:image:height',
            content: height
        });
    }
    _setImageAlt(alt) {
        this._meta.updateTag({
            property: 'og:image:alt',
            content: alt
        });
    }
    _setImage(image) {
        this._setImageUrl(image.url);
        this._setImageType(image.type);
        this._setImageWidth(image.width);
        this._setImageHeight(image.height);
        this._setImageAlt(image.alt);
    }
    _setUrl(url) {
        this._meta.updateTag({
            property: 'og:url',
            content: url
        });
    }
    _setSiteName(content) {
        this._meta.updateTag({
            property: 'og:site_name',
            content: content
        });
    }
    set(data) {
        this._setTitle(data.title);
        this._setType(data.type);
        this._setDescription(data.description);
        this._setImage(data.image);
        this._setUrl(data.url);
        this._setSiteName(this._resolveSiteName(data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: FacebookSeoService, deps: [{ token: i1.Meta }, { token: 'SITE_NAME' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: FacebookSeoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: FacebookSeoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.Meta }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['SITE_NAME']
                }] }] });

class TwitterSeoService {
    constructor(_meta) {
        this._meta = _meta;
    }
    _setCard(contentType) {
        this._meta.updateTag({
            property: 'twitter:card',
            content: contentType
        });
    }
    _setSite() {
        this._meta.updateTag({
            property: 'twitter:site',
            content: ''
        });
    }
    _setTitle(title) {
        this._meta.updateTag({
            property: 'twitter:title',
            content: title
        });
    }
    _setDescription(description) {
        this._meta.updateTag({
            property: 'twitter:description',
            content: description
        });
    }
    _setImageUrl(url) {
        this._meta.updateTag({
            property: 'twitter:image',
            content: url
        });
    }
    _setImageAlt(alt) {
        this._meta.updateTag({
            property: 'twitter:image:alt',
            content: alt
        });
    }
    _setImage(image) {
        this._setImageUrl(image.url);
        this._setImageAlt(image.alt);
    }
    set(data) {
        this._setCard(data.cardType);
        this._setSite();
        this._setTitle(data.title);
        this._setDescription(data.description);
        this._setImage(data.image);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: TwitterSeoService, deps: [{ token: i1.Meta }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: TwitterSeoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: TwitterSeoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.Meta }] });

class SeoService {
    constructor(_meta, _title, _facebook, _twitter) {
        this._meta = _meta;
        this._title = _title;
        this._facebook = _facebook;
        this._twitter = _twitter;
    }
    _setTitle(title) {
        this._title.setTitle(title);
    }
    _setDescription(description) {
        this._meta.updateTag(description);
    }
    _setTags(tags) {
        this._setDescription(tags.description);
    }
    set(data) {
        this._setTitle(data.title);
        this._setTags(data.tags);
        this._facebook.set(data.facebook);
        this._twitter.set(data.twitter);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: SeoService, deps: [{ token: i1.Meta }, { token: i1.Title }, { token: FacebookSeoService }, { token: TwitterSeoService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: SeoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: SeoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.Meta }, { type: i1.Title }, { type: FacebookSeoService }, { type: TwitterSeoService }] });

var TwitterCardType;
(function (TwitterCardType) {
    TwitterCardType["SUMMARY"] = "summary";
    TwitterCardType["SUMMARY_LARGE"] = "summary_large_image";
    TwitterCardType["APP"] = "app";
})(TwitterCardType || (TwitterCardType = {}));

class LocalStorageShimService {
    constructor() {
    }
    store(key, value) {
    }
    retrieve(key) {
        return '';
    }
    hasKey(key) {
        return false;
    }
    clear() {
    }
    removeItems(keys) {
    }
    storeOnAuthSuccessRoute(route) {
    }
    retrieveOnAuthSuccessRoute() {
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: LocalStorageShimService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: LocalStorageShimService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.4", ngImport: i0, type: LocalStorageShimService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

/*
 * Public API Surface of bmx-ngbase
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BmxAngularBaseModule, BrowserAPIService, FacebookSeoService, LocalStorageService, LocalStorageShimService, SeoService, TwitterCardType, TwitterSeoService };
